<h4 class="title-style">{{title}} Group</h4>
<div (click)="this.goToLink()" class="join-container">
    <img src="../../../assets//icons/whatsapp.png" />
    <p class="join-link">Click here or scan to join {{title}} WhatsApp group now!</p>
</div>
<qr-code value={{link}} errorCorrectionLevel="H" size="200" lightColor="#fafafa"></qr-code>